import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    comments: [],
    count: '',
    next: '',
    errors: {}
};

getters['fetchPhotoComments'] = function(state) { return state.comments;}
getters['fetchPhotoCommentsNext'] = function(state) { return state.next;}

const actions = {
    get(context, payload) {
        return ApiService
            .get('photos/' + payload + '/comments/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_COMMENTS', response.data.results);
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_NEXT', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    getNext(context) {
        return ApiService
            .get(context.getters.fetchNext)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_COMMENTS', response.data.results);
                context.commit('SET_NEXT', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    add(context, payload) {
        return ApiService
            .post('comments/add/', payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_COMMENT', response.data)
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    remove(context, payload) {
        return ApiService
            .delete('comments/' + payload + '/remove/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('REMOVE_COMMENT', payload);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    }
};

const mutations = {
    SET_COMMENTS(state, comments) {
        state.comments = comments;
        state.errors = {};
    },
    ADD_COMMENTS(state, comments) {
        state.comments = state.comments.concat(comments);
        state.errors = {};
    },
    ADD_COMMENT(state, comment) {
        state.comments.unshift(comment);
    },
    REMOVE_COMMENT(state, comment) {
        for (let i = 0; i < state.comments.length; i++) {
            if (state.comments[i].id == comment) {
                state.comments.splice(i, 1)
            }
        }
    },
    SET_COUNT(state, count) {
        state.count = count;
        state.errors = {};
    },
    SET_NEXT(state, data) {
        if (data.page < data.num_pages) {
            state.next =
            data.url +
            '?' +
            data.page_param +
            '=' +
            (data.page + 1);
        } else {
            state.next = '';
        }
        state.errors = {};
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
